import { render, staticRenderFns } from "./private-commercial-winner-selection-block.vue?vue&type=template&id=ff124f38&"
import script from "./private-commercial-winner-selection-block.vue?vue&type=script&lang=js&"
export * from "./private-commercial-winner-selection-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff124f38')) {
      api.createRecord('ff124f38', component.options)
    } else {
      api.reload('ff124f38', component.options)
    }
    module.hot.accept("./private-commercial-winner-selection-block.vue?vue&type=template&id=ff124f38&", function () {
      api.rerender('ff124f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/private-commercial-winner-selection-block.vue"
export default component.exports